import { useMemo, useReducer } from "react";
import { listItemId } from "../types";
import { resultReducer } from "./result-reducer";
import { omit } from "ramda";
export var useResultState = function (initialState) {
    var _a = useReducer(resultReducer, initialState), state = _a[0], dispatch = _a[1];
    var resultActions = useMemo(function () { return ({
        setResult: function (result, options) {
            dispatch({ type: "SET_RESULT", payload: result, options: options });
        },
        setMapViewResult: function (result, options) {
            var value = omit(["data", "dataStatus"], result);
            if (result.hasOwnProperty("data")) {
                value.placards = result.data;
            }
            if (result.hasOwnProperty("dataStatus")) {
                value.placardsStatus = result.dataStatus;
            }
            dispatch({
                type: "SET_RESULT",
                payload: value,
                options: options,
            });
        },
        setGalleryViewResult: function (result, options) {
            var value = omit(["data", "dataStatus"], result);
            if (result.hasOwnProperty("data")) {
                value.galleryItems = result.data;
            }
            if (result.hasOwnProperty("dataStatus")) {
                value.galleryStatus = result.dataStatus;
            }
            dispatch({
                type: "SET_RESULT",
                payload: value,
                options: options,
            });
        },
    }); }, []);
    var result = state.result, selection = state.selection;
    var selected = useMemo(function () { return selection.map(function (t) { return t[listItemId]; }); }, [selection]);
    var selectionActions = useMemo(function () { return ({
        selectItem: function (item, resultIdMatchesListId) {
            return dispatch({ type: "SELECT_LIST_ITEM", payload: { selection: item, resultIdMatchesListId: resultIdMatchesListId } });
        },
        unselectItem: function (item) { return dispatch({ type: "UNSELECT_LIST_ITEM", payload: item }); },
        selectAllItems: function () { return dispatch({ type: "SELECT_ALL_LIST_ITEMS" }); },
        unselectAllItems: function () { return dispatch({ type: "UNSELECT_ALL_LIST_ITEMS" }); },
    }); }, []);
    return useMemo(function () { return ({
        result: result,
        selection: selection,
        selected: selected,
        resultActions: resultActions,
        selectionActions: selectionActions,
    }); }, [result, resultActions, selection, selected, selectionActions]);
};
//# sourceMappingURL=use-result-state.js.map